export const CHeaderTopBarFragments = {
  field: `
    fragment headerTopBar on headerTopBar_MatrixField {
      ... on headerTopBar_topBar_BlockType {
        showSafetyInformationLink
        safetyInformationLinkText
        safetyInformationLinkUrl
      }
    }
  `,
}
